import React from "react"
import PropTypes from "prop-types"
import {
  Box,
  Grid,
  Checkbox,
  FormControlLabel,
  InputAdornment,
} from "@mui/material"
import i18n from "i18n"

import InvoiceNumericTextField from "./InvoiceNumericTextField"

const DiscountsConfig = ({
  showProductDiscount,
  onToggleProductDiscount,
  showGlobalDiscount,
  onToggleGlobalDiscount,
  globalDiscountValue,
  setGlobalDiscountValue,
  issued,
  disableDiscountToggles = false,
  disableProductDiscountToggle = false,
  disableGlobalDiscountToggle = false,
}) => {
  const productDiscountToggleDisabled =
    disableDiscountToggles || disableProductDiscountToggle
  const globalDiscountToggleDisabled =
    disableDiscountToggles || disableGlobalDiscountToggle

  return (
    <Grid item xs={12} sm={6} md={7} lg={7} sx={{ mb: 2 }}>
      <Box>
        <Grid container direction="column" sx={{ mb: 2 }}>
          {!issued && (
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={showProductDiscount}
                    disabled={productDiscountToggleDisabled}
                    onChange={e => onToggleProductDiscount(e.target.checked)}
                  />
                }
                label={i18n.t("invoices.productDiscount")}
              />
            </Grid>
          )}
          <Grid item>
            {issued && globalDiscountValue > 0 ? (
              <span>{i18n.t("invoices.globalDiscount")}</span>
            ) : (
              !issued && (
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={showGlobalDiscount}
                      disabled={globalDiscountToggleDisabled}
                      onChange={e => onToggleGlobalDiscount(e.target.checked)}
                    />
                  }
                  label={i18n.t("invoices.globalDiscount")}
                />
              )
            )}
          </Grid>
          {showGlobalDiscount && (
            <Grid item>
              <InvoiceNumericTextField
                size="small"
                value={globalDiscountValue}
                onCommit={setGlobalDiscountValue}
                emptyFallback={0}
                min={0}
                max={100}
                readOnly={issued}
                inputProps={{
                  min: 0,
                  max: 100,
                  step: 0.01,
                  readOnly: issued,
                  style: issued
                    ? { pointerEvents: "none", background: "#f5f5f5" }
                    : {},
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
                sx={{
                  width: 120,
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: issued ? "#f5f5f5" : "inherit",
                  },
                }}
              />
            </Grid>
          )}
        </Grid>
      </Box>
    </Grid>
  )
}

DiscountsConfig.propTypes = {
  showProductDiscount: PropTypes.bool.isRequired,
  onToggleProductDiscount: PropTypes.func.isRequired,
  showGlobalDiscount: PropTypes.bool.isRequired,
  onToggleGlobalDiscount: PropTypes.func.isRequired,
  globalDiscountValue: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]).isRequired,
  setGlobalDiscountValue: PropTypes.func.isRequired,
  issued: PropTypes.bool,
  disableDiscountToggles: PropTypes.bool,
  disableProductDiscountToggle: PropTypes.bool,
  disableGlobalDiscountToggle: PropTypes.bool,
}

export default DiscountsConfig
